import React from 'react'
import { useTheme } from '../../hooks/useTheme'

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <>
      <style>{`
        .theme-toggle-btn {
          background: none;
          border: 0.5px solid var(--border-color-solid);
          color: var(--text-secondary);
          font-family: 'JetBrains Mono', 'Courier New', monospace;
          font-size: 0.75rem;
          padding: 4px 10px;
          border-radius: var(--radius-sm, 4px);
          cursor: pointer;
          transition: all 0.15s ease;
          white-space: nowrap;
        }
        .theme-toggle-btn:hover {
          border-color: var(--accent-blue);
          color: var(--accent-blue);
        }
        .theme-toggle-btn:focus-visible {
          outline: 2px solid var(--accent-blue);
          outline-offset: 2px;
        }
        .theme-toggle-icon {
          margin-right: 5px;
        }
      `}</style>
      <button
        className="theme-toggle-btn"
        onClick={toggleTheme}
        aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
      >
        <span className="theme-toggle-icon">◐</span>
        [{theme === 'dark' ? 'light' : 'dark'}]
      </button>
    </>
  )
}
